import React, { FC } from "react";
import HomePageTitle from "@components/Home/HomePageTitle/HomePageTitle";
import { useTranslation } from "react-i18next";
import { Box, Grid2 as Grid, Stack } from "@mui/material";
import CompanionTile from "@components/Home/CompanionTile";
import GamesCTATile from "@components/Home/Games/GamesCTATile";
import UpcomingScheduleTile from "@components/Home/UpcomingScheduleTile";
import AlbumsTile from "@components/Home/AlbumsTile";
import { DateTime } from "luxon";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import ModeSwitch from "@components/ModeSwitch/ModeSwitch";
import styled from "@emotion/styled";
import DashboardWrapper from "@components/Home/DashboardWrapper";
import { ScreenSize } from "@constants/screen-size";

const PatientDashboardWrapper = styled(DashboardWrapper)`
  @media (min-width: ${ScreenSize.md}px) {
    margin: 0 auto;
    max-width: 1024px;
  }
`;

const PatientDashboard: FC = () => {
  const { t } = useTranslation();
  const patient = useSelector((state: RootState) => state.home.selectedPatient);
  const isPatient = useSelector(
    (state: RootState) => state.auth.user?.isPatient,
  );

  const getGreeting = (): string => {
    const currentHour = DateTime.now().hour;
    let label;
    if (currentHour >= 3 && currentHour < 12) {
      label = "patientDashboard.title.goodMorning";
    } else if (currentHour >= 12 && currentHour < 15) {
      label = "patientDashboard.title.goodAfternoon";
    } else if (currentHour >= 15 && currentHour < 20) {
      label = "patientDashboard.title.goodEvening";
    } else {
      label = "patientDashboard.title.hello";
    }
    return t(label, {
      name: patient?.nickname ? patient?.nickname : patient?.firstName,
    });
  };
  return (
    <PatientDashboardWrapper>
      <Stack
        flexDirection="row"
        gap="16px"
        justifyContent="space-between"
        alignItems="center"
      >
        <HomePageTitle title={getGreeting()} />
        {isPatient ? null : (
          <Box width={{ xs: "140px", sm: "200px" }} marginBottom={4}>
            <ModeSwitch />
          </Box>
        )}
      </Stack>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6, md: 8 }}>
          <CompanionTile />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <GamesCTATile basePath="portal" />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
          <AlbumsTile />
        </Grid>
        <Grid size={12}>
          <UpcomingScheduleTile />
        </Grid>
      </Grid>
    </PatientDashboardWrapper>
  );
};

export default PatientDashboard;
